import React, { useEffect, useRef, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { formatDate, formatToZMW, sumOfArray } from "../../../helpers";
import { FaSpinner } from "react-icons/fa";

const BalanceSheet = ({ rdata, startDate, endDate }) => {
  const [totalAssets, setTotalAssets] = useState(0);
  const [totalLiabilitiesEquity, setTotalLiabilitiesEquity] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true)
  const sumArray = (arr) => arr.reduce((sum, num) => sum + num, 0);
  
  

  const {allData, setAllData} = useOutletContext();
  const componentRef = useRef(null)
  const [loanAmount, setLoanAmount] = useState(0)

  useEffect(() => {
    if(rdata.bills){
      // displayBalanceSheet();
      
      let loan = 0
      rdata.bills.map((res)=>{
        const coa = allData.budget.find(a=>a.id === res.coa_id)?.coa;
        const coaRecord = allData.coa?.find(item => item.account === coa);
        // Check if this is a loan account based on COA type, not hardcoded
        if(coaRecord?.type?.toLowerCase().includes("loan")){
          loan += parseFloat(res.amount) - parseFloat(res.amount) * 0.05
        }
      })

      setLoanAmount(loan)
      setLoading(false)
    }
  }, [rdata]);

  useEffect(() => {
    
      displayBalanceSheet();
    
  }, [loanAmount]);
  

  const displayBalanceSheet = () => {
    let assets = 0;
    let liabilitiesEquity = 0;
    const tableRows = [];

    tableRows.push(
        <tr className="bg-blue-950 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Assets</td>
          <td className="px-4 py-3 border-b border-gray-300">Amount</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

    // Fixed Assets
    tableRows.push(
      <tr className="bg-gray-200 font-bold" key="fixed-assets">
        <td className="px-4 py-3 border-b border-gray-300">Fixed Assets</td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
      </tr>
    );

    rdata.supplier
      .filter((a) => a.type == 1)
      .forEach((res) => {
        if(res.coa != 0){
          const coa = allData.budget.find((b) => b.id === res.coa)?.coa
          const coaRecord = allData.coa?.find(item => item.account === coa);
          // Check if this is a fixed asset based on COA type, not hardcoded
          if (coaRecord && coaRecord.type?.toLowerCase().includes("ass") && !coaRecord.type?.toLowerCase().includes("current")) {
            const fromCoa = sumArray(rdata.journal.filter((a) => a.from_coa === res.coa).map((r) => parseFloat(r.amount)));
            const toCoa = sumArray(rdata.journal.filter((a) => a.to_coa === res.coa).map((r) => parseFloat(r.amount)));
            const amount = parseFloat(res.amount) - fromCoa + toCoa;
            tableRows.push(
              <tr key={`fixed-asset-${res.coa}`}>
                <td className="px-4 py-3 border-b border-gray-300">{coaRecord.name}</td>
                <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(amount)}</td>
                <td className="px-4 py-3 border-b border-gray-300"></td>
                <td className="px-4 py-3 border-b border-gray-300"></td>
              </tr>
            );

            assets += amount;
          }
        }
      });

     

    // Current Assets
    tableRows.push(
      <tr className="bg-gray-200 font-bold" key="current-assets">
        <td className="px-4 py-3 border-b border-gray-300">Current Assets</td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
      </tr>
    );
    rdata.supplier
      .filter((a) => a.type == 1 && a.expense == 'None')
      .forEach((res) => {
        if(res.coa != 0){
        const coa = allData.budget.find((b) => b.id === res.coa)?.coa
        const coaRecord = allData.coa?.find(item => item.account === coa);
        // Check if this is a current asset based on COA type, not hardcoded
        if (coaRecord && coaRecord.type?.toLowerCase().includes("ass") && coaRecord.type?.toLowerCase().includes("current")) {
          let amount = parseFloat(res.amount);
          // Check if this is a loan account based on COA type, not hardcoded
          if(coaRecord.type?.toLowerCase().includes("loan")){
            amount = parseFloat(res.amount) - loanAmount;
          }
          
          if(amount !== 0){
            tableRows.push(
              <tr key={`current-asset-${res.coa}`}>
                <td className="px-4 py-3 border-b border-gray-300">{coaRecord.name}</td>
                <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(amount)}</td>
                <td className="px-4 py-3 border-b border-gray-300"></td>
                <td className="px-4 py-3 border-b border-gray-300"></td>
              </tr>
            );
            assets += amount;
          }
        
        }
      }
      });
let done = []
      rdata.supplier
      .filter((a) => a.type == 1 && a.expense != 'None')
      .forEach((res) => {
        if(res.coa != 0){
        const coa = res.expense
        const coaRecord = allData.coa?.find(item => item.account === coa);
        // Check if this is a current asset based on COA type, not hardcoded
        if (coaRecord && coaRecord.type?.toLowerCase().includes("ass") && coaRecord.type?.toLowerCase().includes("current")) {
          const isz = allData.budget?.find(item => item.coa === coa)?.id
          const fromCoa = sumArray(rdata.journal.filter((a) => a.from_coa === isz).map((r) => parseFloat(r.amount)));
          const toCoa = sumArray(rdata.journal.filter((a) => a.to_coa === isz).map((r) => parseFloat(r.amount)));
          let amount = 0
          if(done.includes(coa)){
            amount = parseFloat(res.amount)
          }else{
            amount = parseFloat(res.amount) - fromCoa + toCoa
          }
          done.push(coa)
          
          if(amount !==0){
            tableRows.push(
              <tr key={`current-asset-${res.coa}`}>
                <td className="px-4 py-3 border-b border-gray-300">{coaRecord.name}</td>
                <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(amount)}</td>
                <td className="px-4 py-3 border-b border-gray-300"></td>
                <td className="px-4 py-3 border-b border-gray-300"></td>
              </tr>
            );
          }
          assets += amount;
        }
      }
      });



      const totalBills = sumArray(rdata.bills.map((res) => parseFloat(res.amount)));
      tableRows.push(
        <tr key="dca">
          <td className="px-4 py-3 border-b border-gray-300">Debtors Control Account</td>
          <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(totalBills - rdata.recs[0]?.amount || 0)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );
      assets += totalBills - rdata.recs[0]?.amount
    // Add Cash
    const cash = parseFloat(rdata.cash[0].difference);
    tableRows.push(
      <tr key="cash">
        <td className="px-4 py-3 border-b border-gray-300">Cash</td>
        <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(cash)}</td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
      </tr>
    );
    assets += cash;
    
    setTotalAssets(assets);
    
    tableRows.push(
        <tr className="bg-gray-800 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Total Assets</td>
          <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(assets)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );
    tableRows.push(
        <tr className="bg-blue-950 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Liabilities</td>
          <td className="px-4 py-3 border-b border-gray-300">Amount</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );
    // Liabilities
    const totalCredit = sumArray(rdata.supplier.filter((a) => a.type == 1).map((res) => parseFloat(res.amount)));
    const totalCred = totalCredit - sumArray(rdata.supplier.filter((a) => a.type == 2).map((res) => parseFloat(res.amount)))
    tableRows.push(
      <tr key="liabilities">
        <td className="px-4 py-3 border-b border-gray-300">Creditors Control Account</td>
        <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(totalCred)}</td>
        
      </tr>
    );
    liabilitiesEquity += totalCred;

    setTotalLiabilitiesEquity(liabilitiesEquity);
    tableRows.push(
        <tr className="bg-gray-800 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Total Liabilities</td>
          <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(liabilitiesEquity)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );
      
      let rev = 0 

      rdata.bills.forEach((res)=>{
        const coa = allData.budget.find(a=>a.id === res.coa_id)?.coa;
        const coaRecord = allData.coa?.find(item => item.account === coa);
        const type = coaRecord?.type?.toLowerCase().includes("rev") ? "revenue" : "expense";
        
        if (type === "revenue") {
          const fromCoa = sumOfArray(
            rdata.journal
              .filter((a) => a.from_coa === res.coa_id)
              .map((entry) => parseFloat(entry.amount))
          );
          const toCoa = sumOfArray(
            rdata.journal
              .filter((a) => a.to_coa === res.coa_id)
              .map((entry) => parseFloat(entry.amount))
          );

          let amu = parseFloat(res.amount);
          // Check if this is a loan account based on COA type, not hardcoded
          if(coaRecord?.type?.toLowerCase().includes("loan")){
            amu = parseFloat(res.amount) * 0.05
          }

          const amount = amu + fromCoa - toCoa;
          rev += amount;
        }
      })

      
      // calculate exp
      let exp = 0
      
      // Process suppliers for revenue and expenses
      rdata.supplier
          .filter((a) => a.type == 1 && a.expense == 'None')
          .forEach((res) => {
              const fromCoa = sumOfArray(
                  rdata.journal
                      .filter((a) => a.from_coa === res.coa)
                      .map((entry) => parseFloat(entry.amount))
              );
              const toCoa = sumOfArray(
                  rdata.journal
                      .filter((a) => a.to_coa === res.coa)
                      .map((entry) => parseFloat(entry.amount))
              );
      
              const coa = allData.budget?.find((b) => b.id === res.coa)?.coa;
              
              if (coa !== undefined) {
                  const amount = parseFloat(res.amount) - fromCoa + toCoa;
                  const coaRecord = allData.coa?.find(item => item.account === coa);
                  const type = coaRecord?.type?.toLowerCase().includes("rev") ? "revenue" : "expense";
                  
                  // Only process revenue and expense accounts, not assets/liabilities
                  if (coaRecord && !coaRecord.type?.toLowerCase().includes("ass") && !coaRecord.type?.toLowerCase().includes("lia")) {
                      if (type === "revenue") {
                          rev += amount;
                      } else {
                          exp += amount;
                      }
                  }
              }
          });

          rdata.journal.forEach((journalEntry) => {
            const coaCode = allData.budget?.find(item => item.id === journalEntry.to_coa)?.coa;
            const amount = parseFloat(journalEntry.amount);
            const coaRecord = allData.coa?.find(item => item.account === coaCode);
            
            if (coaRecord) {
              // Skip assets and liabilities - only process revenue and expenses
              const isAsset = coaRecord.type?.toLowerCase().includes("ass");
              const isLiability = coaRecord.type?.toLowerCase().includes("lia");
              
              if (!isAsset && !isLiability) {
                const type = coaRecord.type?.toLowerCase().includes("rev") ? "revenue" : "expense";
                
                if (type === "revenue") {
                  rev += amount;
                } else {
                  exp += amount;
                }
              }
            }
        });

        // end calculation

      tableRows.push(
        <tr className="bg-blue-950 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Equity</td>
          <td className="px-4 py-3 border-b border-gray-300">Amount</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );


      tableRows.push(
        <tr>
          <td className="px-4 py-3 border-b border-gray-300">Accumulated Fund</td>
          <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(sumArray(rdata.debt.filter(a=>a.type == 1).map((res) => parseFloat(res.amount))))}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );
      tableRows.push(
        <tr className="" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Surplus(Deficit)</td>
          <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(rev - exp)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

   

      tableRows.push(
        <tr className="" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Returned Revenue</td>
          <td className="px-4 py-3 border-b border-gray-300">0</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

      tableRows.push(
        <tr className="" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Revaluation and Reserves</td>
          <td className="px-4 py-3 border-b border-gray-300">0</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

      tableRows.push(
        <tr className="bg-gray-800 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Total Equity</td>
          <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(rev - exp + sumArray(rdata.debt.filter(a=>a.type == 1).map((res) => parseFloat(res.amount))))}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

      tableRows.push(
        <tr className="bg-gray-800 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Liabilities plus Equity</td>
          <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(liabilitiesEquity += rev - exp)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

    setRows(tableRows);
  };

  return (
    <div className="w-full min-h-[500px] h-full rounded-md p-3">
      {
        loading?
        <>
        <div className='flex justify-center items-center h-full w-full text-blue-950 text-5xl p-5 m-5 '>
          <FaSpinner size={50} className="spinner"  /> 
        </div>
        </>
        :
        <>
              <div className="container mx-auto p-4">
         <div className='text-center'>
                      <h2 className='font-bold text-2xl'>{allData.council[0]?.name.toUpperCase()}</h2>
                      <h2 className="font-bold text-2xl my-3">{'Financial Position'.toUpperCase()}</h2>
                      <h3 className='text-xl font-bold'>From {formatDate(startDate)} to {formatDate(endDate)}</h3>
                  </div>
        <table id="balance-sheet" className="w-full g-table">
          <tbody>{rows}</tbody>
        </table>
      </div>
        </>
      }

    </div>
  );
};

export default BalanceSheet;
